/* Praevaleo Produktseite (Dragos 02.11.2026). Hängt an sections/pv-product, pv-look und pv-passt-dazu.
   Variantenwahl, Preis, Lager, In den Warenkorb (/cart/add.js, danach cart:update für Kopfzeile und Warenkorb-Schublade),
   Größen-Popup, Merken, Fortschritt Gratisversand/Geschenk, Look-Summe, Passt dazu mischen.
   Die Lieferzeit-Logik bleibt in snippets/pv-eta. */
(function () {
  'use strict';
  if (window.__pvProduct) return;
  window.__pvProduct = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Geld ---------- */
  function makeMoney(fmt) {
    fmt = fmt || '€{{amount_with_comma_separator}}';
    function digits(c, dec, thou, point) {
      var n = (c / 100).toFixed(dec).split('.');
      n[0] = n[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou);
      return n[1] ? n[0] + point + n[1] : n[0];
    }
    return function (c) {
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        switch (k) {
          case 'amount': return digits(c, 2, ',', '.');
          case 'amount_no_decimals': return digits(c, 0, ',', '.');
          case 'amount_with_comma_separator': return digits(c, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return digits(c, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return digits(c, 2, '\'', '.');
          default: return digits(c, 2, '.', ',');
        }
      });
    };
  }

  /* ---------- Warenkorb ---------- */
  function cartSectionIds() {
    return $$('cart-items-component').map(function (e) { return e.dataset.sectionId; }).filter(Boolean);
  }
  // Legt Teile in den Warenkorb und sagt Kopfzeile und Schublade Bescheid. Gibt { ok, message } zurück.
  async function addToCart(root, items, sourceId) {
    var body = { items: items };
    var ids = cartSectionIds();
    if (ids.length) body.sections = ids.join(',');
    var res, data;
    try {
      res = await fetch(root.dataset.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
      data = await res.json();
    } catch (e) {
      return { ok: false, message: root.dataset.labelErr };
    }
    if (!res.ok || data.status) {
      return { ok: false, message: data.description || data.message || root.dataset.labelErr };
    }
    var cart = null;
    try { cart = await (await fetch(root.dataset.cartUrl, { headers: { Accept: 'application/json' } })).json(); } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart || {},
        sourceId: sourceId || 'pv-product',
        data: { source: 'pv-product', itemCount: cart ? cart.item_count : items.length, sections: data.sections || {}, didError: false }
      }
    }));
    return { ok: true, cart: cart };
  }

  /* ---------- Produktseite ---------- */
  function initProduct(root) {
    var money = makeMoney(root.dataset.money);
    var variants = [];
    try { variants = JSON.parse($('[data-pv-variants]', root).textContent); } catch (e) {}
    var form = $('.pv-form', root);
    var idInput = $('[data-pv-id]', root);
    var priceEl = $('[data-pv-price]', root);
    var inEl = $('[data-pv-in]', root), outEl = $('[data-pv-out]', root);
    var addBtns = $$('[data-pv-add]', root);
    var errEl = $('[data-pv-err]', root);
    var bar = $('[data-pv-bar]', root);
    var scroller = $('[data-pv-scroll]', root);
    var groups = $$('[data-pv-opt]', root);
    var current = null;
    var lblAdd = root.dataset.labelAdd, lblOut = root.dataset.labelOut, lblAdded = root.dataset.labelAdded;

    function selection() {
      return groups.map(function (g) {
        var c = $('.pv-opt__in:checked', g);
        return c ? c.value : null;
      });
    }
    function match(sel) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return sel[i] === o; }); });
    }
    function markOos() {
      var sel = selection();
      groups.forEach(function (g, gi) {
        $$('.pv-opt__in', g).forEach(function (inp) {
          var test = sel.slice(); test[gi] = inp.value;
          var v = match(test);
          var lab = inp.closest('label');
          if (lab) lab.classList.toggle('is-oos', !(v && v.available));
        });
      });
    }
    function setBtns(v) {
      addBtns.forEach(function (b) {
        b.disabled = !v.available;
        var l = $('[data-pv-addlbl]', b);
        if (l) l.textContent = v.available ? lblAdd : lblOut;
      });
    }
    function apply(v, user) {
      if (!v) return;
      current = v;
      idInput.value = v.id;
      priceEl.innerHTML = (v.compare > v.price ? '<s>' + money(v.compare) + '</s>' : '') + '<span>' + money(v.price) + '</span>';
      inEl.hidden = !v.available; outEl.hidden = v.available;
      setBtns(v);
      groups.forEach(function (g, gi) {
        var lab = $('[data-pv-optval]', g);
        if (lab) lab.textContent = v.options[gi];
      });
      markOos();
      var sub = $('[data-pv-barsub]', root);
      if (sub) sub.textContent = money(v.price) + ' · ' + v.options.join(', ');
      var bi = $('.pv-bar__img', root);
      if (bi && v.img) { bi.src = v.img; bi.removeAttribute('srcset'); }
      try {
        var u = new URL(location.href); u.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', u.toString());
      } catch (e) {}
      if (user && v.media) {
        var m = $('[data-media="' + v.media + '"]', root);
        if (m && scroller) {
          if (matchMedia('(max-width: 749px)').matches) scroller.scrollTo({ left: m.offsetLeft, behavior: 'smooth' });
          else if (m !== scroller.firstElementChild) m.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
      document.dispatchEvent(new CustomEvent('pv:variant', { detail: { handle: root.dataset.handle, variant: v } }));
    }
    function onChange(e) {
      var inp = e.target;
      if (!inp.classList || !inp.classList.contains('pv-opt__in')) return;
      var sel = selection();
      var v = match(sel);
      if (!v) {
        // Kombination gibt es nicht: nächste Variante mit dem gewählten Wert nehmen und die übrigen Felder nachziehen.
        var pos = +inp.dataset.pos;
        var cands = variants.filter(function (x) { return x.options[pos] === inp.value; });
        v = cands.find(function (x) { return x.available; }) || cands[0];
        if (v) groups.forEach(function (g, gi) {
          $$('.pv-opt__in', g).forEach(function (r) { r.checked = (r.value === v.options[gi]); });
        });
      }
      apply(v, true);
    }
    form.addEventListener('change', onChange);
    current = match(selection()) || variants[0];
    markOos();
    if (current) {
      var sub0 = $('[data-pv-barsub]', root);
      void sub0;
    }

    // Hinzufügen
    var busy = false;
    function flash(b) {
      var l = $('[data-pv-addlbl]', b);
      if (!l) return;
      l.textContent = lblAdded;
      setTimeout(function () { if (current) l.textContent = current.available ? lblAdd : lblOut; }, 1600);
    }
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (busy || !current || !current.available) return;
      busy = true; errEl.hidden = true;
      addBtns.forEach(function (b) { b.setAttribute('data-busy', ''); });
      // Größenberater: kauft jemand die empfohlene Größe, hängt sie als _Größenberater am Artikel (assets/size-finder.js).
      var item = { id: current.id, quantity: 1 };
      if (window.SizeFinder) Object.assign(item, window.SizeFinder.props(current.options));
      var r = await addToCart(root, [item], form.id);
      addBtns.forEach(function (b) { b.removeAttribute('data-busy'); });
      busy = false;
      if (!r.ok) { errEl.textContent = r.message; errEl.hidden = false; return; }
      addBtns.forEach(flash);
    });

    // Größen-Popup
    var dlg = $('[data-pv-dlg]', root), help = $('[data-pv-sizehelp]', root);
    if (dlg && help) {
      // Tabellen mobil wischbar in einem eigenen Behälter mit Hinweis; Seite dahinter gesperrt, solange das Fenster offen ist.
      $$('.pv-dlg__c table', dlg).forEach(function (tb) {
        if (tb.parentNode.classList.contains('pv-dlg__tw')) return;
        var w = document.createElement('div'); w.className = 'pv-dlg__tw'; tb.parentNode.insertBefore(w, tb); w.appendChild(tb);
        var hint = document.createElement('p'); hint.className = 'pv-dlg__hint'; hint.textContent = 'Seitlich wischen für alle Maße'; w.parentNode.insertBefore(hint, w.nextSibling);
      });
      var dc = $('.pv-dlg__c', dlg); if (dc) { dc.setAttribute('tabindex', '-1'); dc.setAttribute('autofocus', ''); }
      help.addEventListener('click', function () { document.documentElement.classList.add('pv-lock'); if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); });
      dlg.addEventListener('close', function () { document.documentElement.classList.remove('pv-lock'); });
      $('[data-pv-dlgx]', dlg).addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }

    // Merken
    // Merkliste wie insomne: eine Liste von Handles in localStorage (pv-merkliste), Seite /pages/merkliste, Herz im Kopf mit Zähler.
    var heart = $('[data-pv-heart]', root), handle = root.dataset.handle;
    if (heart && handle) {
      var M = window.pvMerk;
      if (M && M.has(handle)) heart.setAttribute('aria-pressed', 'true');
      heart.addEventListener('click', function () {
        var on = heart.getAttribute('aria-pressed') !== 'true';
        heart.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (window.pvMerk) window.pvMerk.set(handle, on);
      });
    }

    // Mitlaufende Leiste (mobil): erst sichtbar, wenn der Marker hinter „Fragen?“ oben aus dem Bild ist. Kein Scroll-Listener.
    var mark = $('[data-pv-bar-mark]', root);
    if (bar && mark && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[es.length - 1];
        var on = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', on);
        bar.inert = !on;
      }).observe(mark);
    } else if (bar) { bar.classList.add('is-on'); bar.inert = false; }

    // Punkte der Galerie (mobil)
    var dots = $$('[data-pv-dots] span', root);
    if (scroller && dots.length) {
      var raf = 0;
      scroller.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var w = scroller.clientWidth || 1, i = Math.round(scroller.scrollLeft / w);
          dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        });
      }, { passive: true });
    }

    // Fortschritt Gratisversand und Geschenk
    var prog = $('[data-pv-prog]', root);
    if (prog) {
      var ship = +prog.dataset.ship, gift = +prog.dataset.gift;
      var t = $('[data-pv-progt]', prog), fill = $('[data-pv-progfill]', prog);
      var truck = $('[data-pv-truck]', prog), gi = $('[data-pv-gift]', prog);
      var tpl = [prog.dataset.t1, prog.dataset.t2, prog.dataset.t3];
      var esc = function (s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
      var noZero = function (c) { return money(c).replace(/[.,]00(?!\d)/, ''); };
      var paint = function (total) {
        var k = total < ship ? 0 : (total < gift ? 1 : 2);
        var am = k === 0 ? ship - total : (k === 1 ? gift - total : 0);
        t.innerHTML = esc(tpl[k]).replace('{amount}', '<strong>' + money(am) + '</strong>')
          .replace('{gift}', noZero(gift)).replace('{ship}', noZero(ship));
        // Wagen sitzt bei 75 % (wie im Liquid): stückweise füllen.
        var pct = total < ship ? total * 75 / ship : 75 + (total - ship) * 25 / Math.max(1, gift - ship);
        fill.style.width = Math.min(100, pct) + '%';
        truck.classList.toggle('is-done', total >= ship);
        gi.classList.toggle('is-done', total >= gift);
      };
      document.addEventListener('cart:update', async function (e) {
        var c = e.detail && e.detail.resource;
        if (!c || typeof c.total_price !== 'number') {
          try { c = await (await fetch(root.dataset.cartUrl)).json(); } catch (x) { return; }
        }
        paint(c.total_price);
      });
    }
  }

  /* ---------- Look ---------- */
  function initLook(root) {
    var money = makeMoney(root.dataset.money);
    var pct = +root.dataset.pct || 0;
    var all = $$('[data-pv-lkitem]', root);
    var main = all.filter(function (it) { return it.dataset.main === '1'; });
    var alts = all.filter(function (it) { return it.dataset.main !== '1'; });
    var cur = 0;
    // Immer genau zwei Teile: das Produkt der Seite und das gerade sichtbare Partnerteil
    var items = main.concat(alts.slice(0, 1));
    var addBtn = $('[data-pv-lkadd]', root), lbl = $('[data-pv-lklbl]', root), errEl = $('[data-pv-lkerr]', root);
    var sub = $('[data-pv-lksub]', root), disc = $('[data-pv-lkdisc]', root), old = $('[data-pv-lkold]', root), tot = $('[data-pv-lktot]', root);

    function sel(item) { return $('[data-pv-lksel]', item); }
    function opt(item) { var s = sel(item); return s.selectedOptions[0] && s.value ? s.selectedOptions[0] : null; }
    function sums() {
      var sum = 0, top = 0;
      items.forEach(function (it) {
        var o = opt(it);
        var cents = o ? +o.dataset.price : null;
        if (cents === null) {
          // Noch keine Größe: Preis aus der ersten wählbaren Variante
          var first = $$('option[data-price]', sel(it)).find(function (x) { return !x.disabled; }) || $('option[data-price]', sel(it));
          cents = first ? +first.dataset.price : 0;
        }
        $('[data-pv-lkprice]', it).textContent = money(cents);
        sum += cents;
        if (cents > top) top = cents;
      });
      // Zwei Shopify-Automatiken (Kaufe X, bekomme Y), die höhere gewinnt: die Prozente gehen aufs teurere Teil.
      var d = Math.round(top * pct / 100);
      sub.textContent = money(sum);
      if (disc) disc.textContent = '−' + money(d);
      if (old) old.textContent = money(sum);
      tot.textContent = money(sum - d);
    }
    // Partnerteil durchblättern (Dragos 03.11.2026, wie Mix and Match bei Moray): Pfeile, Wischen, Pfeiltasten
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function warm(i) {
      var it = alts[(i + alts.length) % alts.length];
      var pic = it && $('.pv-lk__pic', it);
      if (pic && pic.loading === 'lazy') pic.loading = 'eager';
    }
    function show(i, dir) {
      if (alts.length < 2) return;
      i = (i + alts.length) % alts.length;
      if (i === cur) return;
      var fe = document.activeElement, hadFocus = false;
      try { hadFocus = alts[cur].contains(fe) && fe.matches(':focus-visible'); } catch (x) {}
      var was = alts[cur], next = alts[i];
      was.hidden = true;
      next.hidden = false;
      if (!reduce) {
        next.classList.remove('is-in-l', 'is-in-r');
        void next.offsetWidth;
        next.classList.add(dir < 0 ? 'is-in-l' : 'is-in-r');
      }
      cur = i;
      items[1] = next;
      sel(next).classList.remove('is-missing');
      errEl.hidden = true;
      if (hadFocus) { var b = $(dir < 0 ? '[data-pv-lkprev]' : '[data-pv-lknext]', next); if (b) b.focus({ preventScroll: true }); }
      var live = $('[data-pv-lklive]', root), first = $$('option[data-price]', sel(next)).find(function (x) { return !x.disabled; });
      if (live) live.textContent = next.dataset.title + (first ? ', ' + money(+first.dataset.price) : '') + ', ' + (i + 1) + ' von ' + alts.length;
      var nm = $('[data-pv-lookname]');
      if (nm) nm.textContent = next.dataset.title;
      warm(i + 1); warm(i - 1);
      sums();
    }
    if (alts.length > 1) {
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-pv-lkprev]')) show(cur - 1, -1);
        else if (e.target.closest('[data-pv-lknext]')) show(cur + 1, 1);
      });
      var rot = $('[data-pv-lkrot]', root), x0 = null, y0 = 0;
      rot.addEventListener('keydown', function (e) {
        if (e.target.tagName === 'SELECT') return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(cur - 1, -1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); show(cur + 1, 1); }
      });
      rot.addEventListener('touchstart', function (e) {
        if (e.target.closest('select')) { x0 = null; return; }
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      rot.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) show(cur + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
      }, { passive: true });
      // Nachbarn vorladen, sobald die Sektion in Sicht kommt
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { warm(1); warm(-1); io.disconnect(); }
        }, { rootMargin: '300px' });
        io.observe(root);
      } else { warm(1); warm(-1); }
    }
    all.forEach(function (it) {
      sel(it).addEventListener('change', function () {
        var o = opt(it);
        var pic = $('.pv-lk__pic', it);
        if (o && o.dataset.img && pic) { pic.src = o.dataset.img; pic.removeAttribute('srcset'); }
        sel(it).classList.remove('is-missing');
        errEl.hidden = true;
        sums();
      });
    });
    // Größe der Kaufbox übernehmen
    document.addEventListener('pv:variant', function (e) {
      var main = items.find(function (it) { return it.dataset.main === '1' && it.dataset.handle === e.detail.handle; });
      if (!main) return;
      var s = sel(main), v = e.detail.variant;
      var o = $$('option', s).find(function (x) { return +x.value === v.id; });
      if (o && !o.disabled) { s.value = o.value; s.dispatchEvent(new Event('change')); }
    });
    sums();

    var busy = false, lblAdd = root.dataset.labelAdd;
    addBtn.addEventListener('click', async function () {
      if (busy) return;
      errEl.hidden = true;
      var missing = items.filter(function (it) { return !opt(it); });
      if (missing.length) {
        missing.forEach(function (it) { sel(it).classList.add('is-missing'); });
        errEl.textContent = root.dataset.labelPick; errEl.hidden = false;
        sel(missing[0]).focus();
        return;
      }
      busy = true; addBtn.setAttribute('data-busy', '');
      var r = await addToCart(root, items.map(function (it) { return { id: +opt(it).value, quantity: 1 }; }), 'pv-look');
      busy = false; addBtn.removeAttribute('data-busy');
      if (!r.ok) { errEl.textContent = r.message; errEl.hidden = false; return; }
      lbl.textContent = root.dataset.labelAdded;
      setTimeout(function () { lbl.textContent = lblAdd; }, 1600);
    });
  }

  /* ---------- Passt dazu ---------- */
  function initRecs(grid) {
    var cards = $$('.pv-rec', grid);
    if (cards.length < 2) return;
    var best = cards.filter(function (c) { return c.dataset.bs === '1'; });
    var lead = best.length ? best[Math.floor(Math.random() * best.length)] : null;
    var rest = cards.filter(function (c) { return c !== lead; });
    for (var i = rest.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = rest[i]; rest[i] = rest[j]; rest[j] = tmp;
    }
    (lead ? [lead].concat(rest) : rest).forEach(function (c) { grid.appendChild(c); });
  }

  function boot() {
    $$('[data-pv-product]').forEach(initProduct);
    $$('[data-pv-look]').forEach(initLook);
    $$('[data-pv-recs]').forEach(initRecs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Theme-Editor: Sections werden neu geladen
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target;
    $$('[data-pv-product]', r).forEach(initProduct);
    $$('[data-pv-look]', r).forEach(initLook);
    $$('[data-pv-recs]', r).forEach(initRecs);
  });
})();
